import React from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import { useExercise } from '../ExerciseProvider'
import { RadioGroup, RadioGroupItem } from '~/lib/ui/radio-group'
import {
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Select,
} from '~/lib/ui/select'

const PartThree = () => {
  const { getResponse } = useExercise()
  const { t } = useTranslation('discovering_your_consulting_niche')
  const instructions = t('pages.2.instructions')
  const letterSlugs = ['a', 'b', 'c', 'd', 'e']
  const questionOneResponse = getResponse(0, 1)
  const letter = letterSlugs.includes(questionOneResponse)
    ? questionOneResponse
    : 'f'
  const niche = t(`pages.2.niches.${letter}`, {
    returnObjects: true,
  })
  const questions = t('pages.2.questions', {
    returnObjects: true,
  })

  return (
    <div>
      <div className="subtitle">{instructions}</div>
      <Niche niche={niche} />
      <div className="mt-2">{t('pages.2.niches.all')}</div>
      <div>
        {questions.map((questionInfo, idx) => (
          <Question
            key={`question-${idx}`}
            questionInfo={questionInfo}
            questionIdx={idx}
          />
        ))}
      </div>
      <div className="mt-2">{t('pages.2.text')}</div>
    </div>
  )
}

export default PartThree

const Niche = ({ niche }) => {
  const { text, options, additional_tips } = niche
  const { t } = useTranslation('discovering_your_consulting_niche')
  return (
    <div className="flex flex-col gap-4">
      <div className="subtitle">{niche.title}</div>
      <div className="flex flex-col gap-2">
        {options &&
          options.map((option, idx) => (
            <p key={`niche-option-${idx}`}>
              <span className="font-bold">{option.title}: </span>
              {option.description}
            </p>
          ))}
        {text &&
          text.map((line, idx) => (
            <div key={`niche-text-${idx}`} className="text-sm">
              {line}
            </div>
          ))}
        <div>
          <div className="font-bold">{t('pages.2.additional_tips')}:</div>
          <ul className="mt-2 list-disc pl-6">
            {additional_tips.map((tip, idx) => (
              <li key={`niche-tip-${idx}`} className="text-sm">
                {tip}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

const Question = ({ questionInfo, questionIdx }) => {
  const { t } = useTranslation('discovering_your_consulting_niche')
  const { handleChange, getResponse, industries } = useExercise()
  const { options, type } = questionInfo
  const handleValueChange = (option) => {
    handleChange(2, questionIdx, null, option)
  }
  const response = getResponse(2, questionIdx)
  return (
    <>
      <div className="subtitle my-2">{questionInfo.question}</div>
      {type === 'dropdown' && (
        <Select
          onValueChange={handleValueChange}
          value={getResponse(2, questionIdx)}
        >
          <SelectTrigger>
            <SelectValue placeholder={t('select_placeholder')} />
          </SelectTrigger>
          <SelectContent>
            {industries.map((industry, idx) => (
              <SelectItem key={`page-3-dropdown-${idx}`} value={industry}>
                {industry}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
      {type !== 'dropdown' && (
        <RadioGroup onValueChange={handleValueChange} defaultValue={response}>
          {options.map((option, idx) => (
            <div
              key={`page-3-radio-${questionIdx}-${idx}`}
              className="flex items-center gap-2"
            >
              <RadioGroupItem value={option} id={option} />
              <label className="!font-normal" htmlFor={option}>
                {option}
              </label>
            </div>
          ))}
        </RadioGroup>
      )}
    </>
  )
}
